import {
  SectionGallery,
  SectionQuote,
  SectionSingleImage,
  SectionText,
  SectionVideo
} from '@/ui/Sections'
import { memo } from 'react'
import { ContentBlocksProps } from './type'

const ContentBlocks = ({
  blocks,
  layout = 'default'
}: {
  blocks?: ContentBlocksProps[]
  layout?: 'default' | 'wrapped'
}) => {
  if (!blocks || !blocks?.length) {
    return null
  }

  return blocks?.map((block, index) => {
    switch (block.type) {
      case 'textBlock':
        return (
          <SectionText
            layout={layout}
            key={index?.toString()}
            text={block?.text}
          />
        )
      case 'quote':
        return (
          <SectionQuote
            key={index?.toString()}
            text={block?.text}
            layout={layout}
            author={block?.author}
            authorDescription={block?.authorDescription}
          />
        )
      case 'carouselBlock': {
        return <SectionGallery key={index?.toString()} images={block?.images} />
      }
      case 'imageBlock': {
        if (!block?.images) {
          return null
        }
        if (block?.images?.length > 1) {
          return (
            <SectionGallery key={index?.toString()} images={block?.images} />
          )
        } else {
          return (
            <SectionSingleImage
              layout={layout}
              key={index?.toString()}
              images={block?.images}
            />
          )
        }
      }
      case 'videoBlock':
        return (
          <SectionVideo
            key={index?.toString()}
            section={{
              appearance: {
                spaceBefore: 'm',
                spaceAfter: 'm'
              }
            }}
            videos={[
              {
                src: block?.link as string,
                provider: 'youtube'
              }
            ]}
            description={block?.title}
          />
        )
    }
  })
}

export default memo(ContentBlocks)
